// Fragment "layoutNav (lot D)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
// Note : les libellés de nav.* / section.* / layout.* / banner.* consommés par
// adminNav.js, AdminSidebar.jsx et SuperAdminBanner.jsx existent déjà dans
// admin/base.js — ce fragment ne couvre que le upsell Academy Pro (AcademyProUpsell.jsx).
// crm-module BEGIN C1.01 — plus the CRM section's sub-item labels (nav.crm*). crm-module END
export default {
  fr: {
    "upsell.academyPro.badge": "☾ Academy",
    "upsell.academyPro.title": "Votre Academy décolle — passez à Academy Pro",
    "upsell.academyPro.description": "Cohortes & Pathways illimités, white-label, certificats & CE marketplace.",
    "upsell.academyPro.cta": "Découvrir Academy Pro",
    // crm-module BEGIN C1.01 — the CRM section's sub-items (admin/layout/adminNav.js)
    "nav.crmDashboard": "Tableau de bord",
    "nav.crmClients": "Clients",
    "nav.crmForms": "Formulaires",
    "nav.crmImport": "Importer",
    "nav.crmEmail": "Automatisation des e-mails",
    "nav.crmPacks": "Forfaits",
    "nav.crmTeam": "Équipe",
    "nav.crmSettings": "Réglages",
    // crm-module END
  },
  en: {
    "upsell.academyPro.badge": "☾ Academy",
    "upsell.academyPro.title": "Your Academy is taking off — upgrade to Academy Pro",
    "upsell.academyPro.description": "Unlimited cohorts & pathways, white-label, certificates & CE marketplace.",
    "upsell.academyPro.cta": "Discover Academy Pro",
    // crm-module BEGIN C1.01 — the CRM section's sub-items (admin/layout/adminNav.js)
    "nav.crmDashboard": "Dashboard",
    "nav.crmClients": "Clients",
    "nav.crmForms": "Forms",
    "nav.crmImport": "Import",
    "nav.crmEmail": "Email Automation",
    "nav.crmPacks": "Packs",
    "nav.crmTeam": "Team",
    "nav.crmSettings": "Settings",
    // crm-module END
  },
  es: {
    "upsell.academyPro.badge": "☾ Academy",
    "upsell.academyPro.title": "Tu Academy está despegando — pasa a Academy Pro",
    "upsell.academyPro.description": "Cohortes y Pathways ilimitados, marca blanca, certificados y CE marketplace.",
    "upsell.academyPro.cta": "Descubre Academy Pro",
    // crm-module BEGIN C1.01 — the CRM section's sub-items (admin/layout/adminNav.js)
    "nav.crmDashboard": "Panel",
    "nav.crmClients": "Clientes",
    "nav.crmForms": "Formularios",
    "nav.crmImport": "Importar",
    "nav.crmEmail": "Automatización de correos",
    "nav.crmPacks": "Bonos",
    "nav.crmTeam": "Equipo",
    "nav.crmSettings": "Ajustes",
    // crm-module END
  },
};
